module.exports = __webpack_public_path__ + "static/media/background_light.5e2b7b1a.svg";